// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oEcghXa5_8wv3PP_9zPl{padding-top:4px;padding-left:12px;padding-right:12px}.oEcghXa5_8wv3PP_9zPl .react-datepicker__month-container{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapCalendarClassNameDropdown": `oEcghXa5_8wv3PP_9zPl`
};
export default ___CSS_LOADER_EXPORT___;
